import PropTypes from 'prop-types';
import React, { useLayoutEffect, useState } from 'react';
import styled from 'styled-components';

const Hidden = styled.div`
  display: none;
`;

const Responsive = ({ children, min = 0, max = 9999 }) => {
  const [width] = useWindowSize();
  const render = width >= min && width <= max;

  return <>{render ? children : <Hidden />}</>;
};

function useWindowSize() {
  const [size, setSize] = useState([0, 0]);
  useLayoutEffect(() => {
    function updateSize() {
      setSize([window.innerWidth, window.innerHeight]);
    }

    window.addEventListener('resize', updateSize);
    updateSize();

    return () => window.removeEventListener('resize', updateSize);
  }, []);

  return size;
}

Responsive.propTypes = {
  children: PropTypes.node,
  min: PropTypes.number,
  max: PropTypes.number,
};

export default Responsive;
